import { render, staticRenderFns } from "./VeHrPeixunForm.vue?vue&type=template&id=5fbe6316"
import script from "./VeHrPeixunForm.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports